import React from 'react'

import { IconSVGProps } from '@sidecar-components/atoms/Icon/Icon.types'

export const Ambulance = ({
  className,
  pathClass,
  size = 6,
  ...rest
}: IconSVGProps) => (
  <svg
    aria-label="Ambulance icon"
    className={`h-${size} w-${size} ${className}`}
    viewBox="0 0 64 64"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <path
      className={`color-iconBrand-default ${pathClass}`}
      fillRule="evenodd"
      clipRule="evenodd"
      d="M38 9L37 12H5C2.5 12 0 14.5 0 17V44C0 46.5 2.5 49 5 49H10C10.8044 49 11.5 48.3044 11.5 47.5C11.5 46.6971 10.8044 46 10 46H5C4 46 3 45 3 44V17C3 16 4 15 5 15H42.5C43.6171 15 45.256 15.5499 45.7898 16.3528C46.5505 17.4946 47.7724 19.6154 48.4545 20.9797L52.464 29H40V22H44C45 22 45.75 21.5 45.75 20.5C45.75 19.5 45 19 44 19H38.4545C37.6502 19 37 19.6502 37 20.4545V30C37 31 38 32 39 32H55.2398L58.3658 34.4997C59.2705 35.2241 61 36.8436 61 38V44C61 45 60 46 59 46H56C55.1956 46 54.5 46.6956 54.5 47.5C54.5 48.3029 55.1956 49 56 49H59C61.5 49 64 46.5 64 44V38C64 35.9447 61.7898 33.515 60.1825 32.2306L55.432 28.4285L51.0567 19.6794C50.3178 18.2015 49.0393 15.9863 48.2102 14.7383C47.1367 13.1266 45.1018 12 43 12H42L41 9H38Z"
    />
    <path
      className={`color-iconBrand-default ${pathClass}`}
      fillRule="evenodd"
      clipRule="evenodd"
      d="M42.5 49H22.5C21.6705 49 21 48.328 21 47.5C21 46.6705 21.6705 46 22.5 46H42.5C43.3295 46 44 46.6705 44 47.5C44 48.328 43.3295 49 42.5 49Z"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9 47.5C9 51.637 12.366 55 16.5 55C20.637 55 24 51.637 24 47.5C24 43.366 20.637 40 16.5 40C12.366 40 9 43.366 9 47.5ZM12 47.5C12 45.019 14.019 43 16.5 43C18.981 43 21 45.019 21 47.5C21 49.981 18.981 52 16.5 52C14.019 52 12 49.981 12 47.5Z"
      className={`color-iconBrand-default ${pathClass}`}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M42 47.5C42 51.637 45.366 55 49.5 55C53.637 55 57 51.637 57 47.5C57 43.366 53.637 40 49.5 40C45.366 40 42 43.366 42 47.5ZM45 47.5C45 45.019 47.019 43 49.5 43C51.981 43 54 45.019 54 47.5C54 49.981 51.981 52 49.5 52C47.019 52 45 49.981 45 47.5Z"
      className={`color-iconBrand-default ${pathClass}`}
    />
    <path
      className={`color-iconBrand-default ${pathClass}`}
      fillRule="evenodd"
      clipRule="evenodd"
      d="M16.5 49C15.6735 49 15 48.3265 15 47.5C15 46.6735 15.6735 46 16.5 46C17.3295 46 18 46.6735 18 47.5C18 48.3265 17.3295 49 16.5 49"
    />
    <path
      className={`color-iconBrand-default ${pathClass}`}
      fillRule="evenodd"
      clipRule="evenodd"
      d="M49.5 49C48.6735 49 48 48.3265 48 47.5C48 46.6735 48.6735 46 49.5 46C50.3295 46 51 46.6735 51 47.5C51 48.3265 50.3295 49 49.5 49"
    />
    <path
      className={`color-iconBrand-default ${pathClass}`}
      fillRule="evenodd"
      clipRule="evenodd"
      d="M20 38C14.4871 38 10 33.5143 10 28C10 22.4871 14.4871 18 20 18C25.5129 18 30 22.4871 30 28C30 33.5143 25.5129 38 20 38"
    />
    <path
      className={`color-iconPrimary-disabled ${pathClass}`}
      fillRule="evenodd"
      clipRule="evenodd"
      d="M20 21C16.1416 21 13 24.1416 13 28C13 31.8612 16.1416 35 20 35C23.8612 35 27 31.8612 27 28C27 24.1416 23.8612 21 20 21"
    />
    <path
      className={`color-iconBrand-default ${pathClass}`}
      fillRule="evenodd"
      clipRule="evenodd"
      d="M18.5 31.5C18.5 32.3295 19.1705 33 20 33C20.8295 33 21.5 32.3295 21.5 31.5V29.5H23.5C24.3295 29.5 25 28.8295 25 28C25 27.172 24.3295 26.5 23.5 26.5H21.5V24.5C21.5 23.672 20.8295 23 20 23C19.1705 23 18.5 23.672 18.5 24.5V26.5H16.5C15.6705 26.5 15 27.172 15 28C15 28.8295 15.6705 29.5 16.5 29.5H18.5V31.5Z"
    />
  </svg>
)
